const React = require('react');
const Base = require('./Base');
const Intro = require('./Intro');
const {AuthRequestError} = require('../../../dumb/FormInputs');


module.exports = (props) => {
  return (
    <Base
      cachedAccount={props.cachedAccount}
      loading={props.loading}
      content={(<div
        className="w1200 wmax mhA ph15"
      >
        <div className="cfx mh-15 (lt|ph15|w1/2|w@m)>1">
          <Intro/>
          <div className="mt40@m">
            <div
              className="f29 fw3 lh44 hmin44 lts0em"
            >{props.title}</div>
            <div
              className="mt20 f23 fw3 lh34 hmin34@d lts0em"
            >
              {props.description}
              <AuthRequestError formCtx={props.formCtx} />
            </div>
            <div className="mt35 hmin120@d layoutRow fhaC fvaS">
              <div className="w">{props.content}</div>
            </div>
            <div
              className="hmin84 hmin20@m layoutRow fhaS fvaS"
            >{props.beforeFooter}</div>
            <div className="hmin60 layoutRow fhaB fvaC dB@m">
              {props.control}
              <div className="layoutRow fhaS fvaC mt40@m pl20 pl@m">
                {props.additional}
              </div>
            </div>
          </div>
        </div>
      </div>)}
    />
  );
};
